module.exports = __webpack_public_path__ + "img/3.463b0309.png";